import { render, staticRenderFns } from "./IssueRank.vue?vue&type=template&id=6eba1b66&scoped=true"
import script from "./IssueRank.vue?vue&type=script&lang=js"
export * from "./IssueRank.vue?vue&type=script&lang=js"
import style0 from "./IssueRank.vue?vue&type=style&index=0&id=6eba1b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eba1b66",
  null
  
)

export default component.exports